<template>
  <v-app id="app">
    <TheNavbar
      @show-contact-us="dialog = true"
      :page.sync="page"
    />
    <v-content>
      <router-view
        @show-contact-us="dialog = true"
        :page.sync="page"
      />
    </v-content>
    <ContactUsModal :dialog.sync="dialog" />
    <TheFooter />
  </v-app>
</template>

<script>
import localforage from 'localforage';

import TheNavbar from "@/components/TheNavbar.vue";
import ContactUsModal from "@/components/Modals/ContactUsModal";
import TheFooter from "@/components/TheFooter.vue";

export default {
  name: "app",
  data() {
    return {
      dialog: false,
      page: 1,
    };
  },
  components: {
    TheNavbar,
    ContactUsModal,
    TheFooter,
  },
  watch: {
    page: {
      handler() {
        // user begins, and we confirm before they redirect.
        window.onbeforeunload = function() {
          return "Changes you made may not be saved.";
        };
      },
    },
  },
  mounted() {
    this.$store.dispatch('fetchActiveCampaign');
    localforage.getItem('copq', function (err, value) {
        return JSON.parse(value);
      })
      .then((value) => {
        const user = JSON.parse(value).user
        this.$store.dispatch('fetchUser', { user });
      });
  },
};
</script>
